import {cn} from '../../lib/utils';
import {ExternalLink} from '../ExternalLink';
import {Typography} from '../Typography';

export interface ConsentLinksTextProps {
  prefix: string;
  termsLabel: string;
  termsHref: string;
  connector: string;
  privacyLabel: string;
  privacyHref: string;
  className?: string;
}

/**
 * "I agree to the Terms of Use and Privacy Policy" text with the two legal links inline.
 * Shared between the web app's trust-account consent checkboxes and the pay app's payment
 * consent checkbox — every string/href is caller-supplied since each app owns its own i18n.
 */
export function ConsentLinksText({
  prefix,
  termsLabel,
  termsHref,
  connector,
  privacyLabel,
  privacyHref,
  className
}: ConsentLinksTextProps) {
  return (
    <Typography
      as="span"
      size="xs"
      color="secondary"
      className={cn('whitespace-normal text-right', className)}
    >
      {prefix}
      <ExternalLink
        href={termsHref}
        className="font-semibold hover:text-brand-primary_hover dark:hover:text-fg-link"
      >
        {termsLabel}
      </ExternalLink>
      {connector}
      <ExternalLink
        href={privacyHref}
        className="font-semibold hover:text-brand-primary_hover dark:hover:text-fg-link"
      >
        {privacyLabel}
      </ExternalLink>
    </Typography>
  );
}
